var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-card"},[(_vm.title)?_c('h2',{staticClass:"title"},[_c('span',{staticClass:"line"}),_vm._v(_vm._s(_vm.title)+" "),_c('div',{style:(`float:${_vm.isRight?'right':'inherit'};display:${!_vm.isRight?'inline-block':'block'}`)},[_vm._t("extend")],2)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }